<template>
  <div class="kk-designer__drop-indicator" :class="`kk-designer__drop-indicator-${position}`">
    <custom-icon class-name="icon-chevron-right kk-designer__drop-indicator-icon" />
  </div>
</template>

<script>
import CustomIcon from "../commons/CustomIcon.vue";

export default {
  components: { CustomIcon },
  computed: {
    position() {
      return this.$store.state.pdesign.dropIndicator.position;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables";

.kk-designer__drop-indicator {
  position: absolute;
  transition: all 100ms;
  z-index: 260;
  top: 0;
  transform: translateY(-65%);
  left: -1rem;
  &-icon {
    font-size: 2rem;
    width: 1rem;
    height: 1rem;
    color: @kk-color-primary-blue;
  }
  &-after {
    transform: translateY(63.5%);
    top: unset;
    bottom: 0;
  }
}
</style>
